module.exports = "/images/menu-contact.svg?4e2a85b3d0e8fd083b8043adcca7f2ec";